import { Statistics } from "./Statistics";

export * from "./Statistics";
export default Statistics;
